'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { Button } from '@/components/ui/button'
import { MessageSquarePlus, Loader2 } from 'lucide-react'

interface AddReviewButtonProps {
  className?: string
}

export default function AddReviewButton({ className }: AddReviewButtonProps) {
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()

  const handleAddReview = async () => {
    setIsLoading(true)
    
    try {
      // Navigate to leave-review page
      router.push('/leave-review')
    } catch (error) {
      console.error('Navigation error:', error)
      setIsLoading(false)
    }
    // Note: Don't set loading to false here as navigation will unmount the component
  }

  return (
    <Button 
      variant="default" 
      size="sm" 
      className={`flex-1 sm:flex-none gap-1 bg-[var(--color-brand-primary)] hover:bg-[var(--color-brand-primary-hover)] text-white h-9 px-2 sm:px-3 ${className || ''}`}
      onClick={handleAddReview}
      disabled={isLoading}
    >
      {isLoading ? (
        <Loader2 size={15} className="animate-spin" />
      ) : (
        <MessageSquarePlus size={15} />
      )}
      <span className="hidden sm:inline">
        {isLoading ? 'Loading...' : 'Add Review'}
      </span>
    </Button>
  )
} 